import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'antiFraudCaseController';
export default {
    /**
     * 协催管理-反欺诈调查案-列表数据
     */
    queryAntiFraudCaseList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryAntiFraudCaseList',
        type: requestType.Get,
    },
    /**
     * 协催管理-反欺诈调查案件-设置调查结果
     */
    setAntiFraudCaseByCaseId: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'setAntiFraudCaseByCaseId',
        type: requestType.Post,
    },
    /**
     * 查看反欺诈设置纪录
     */
    getCheatDetails: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCheatDetails',
        type: requestType.Get,
    }
};
